export default __webpack_public_path__ + "static/media/Icon-metro-folder-download.a27be382.svg";